import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { pathUrl } from 'apps/di-ld/src/app/configs';
import { JsInterfaceService } from 'apps/di-ld/src/app/core/services/shared/js-interface.service';
import { HttpService } from '@web-di-ld/apps/http';
import { AppStateService } from 'apps/di-ld/src/app/app-state.service';
import { take } from 'rxjs/operators';
import {
  CustomDimensions,
  EventGATagging,
} from 'apps/di-ld/src/app/core/interfaces/js-interface.interface';
import { FLOW_STATE } from 'apps/di-ld/src/app/core/interfaces';

@Component({
  selector: 'web-di-ld-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  @Input() title!: string;
  @Input() url!: string;
  public productType!: string;

  constructor(
    private router: Router,
    private location: Location,
    private jsInterfaceService: JsInterfaceService,
    private httpService: HttpService,
    private appState: AppStateService
  ) {}

  ngOnInit(): void {
    this.setProductType();
  }

  async setProductType() {
    const productType = await this.httpService.productType$
      .pipe(take(1))
      .toPromise();
    this.productType = this.appState.snapshot.loanProduct
      ? this.appState.snapshot.loanProduct.productType
      : productType;
  }

  previousUrl(path: string) {
    const { flow, enterFlow } = this.appState.snapshot.flow;
    let returnPath = this.getPath(path, flow, enterFlow);
    if (returnPath === path) {
      return this.getPath(path);
    } else {
      return returnPath;
    }
  }

  getPath(path: string, flow?: FLOW_STATE, enterFlow?: FLOW_STATE) {
    switch (path) {
      case pathUrl.loanApply.apply:
        return flow === FLOW_STATE.COMFIRM
          ? pathUrl.confirmingDetails
          : enterFlow === FLOW_STATE.CALCULATE
          ? pathUrl.loanApply.calculation
          : pathUrl.loanProductShelf;
      case pathUrl.loanApply.productDetail:
        return pathUrl.loanApply.apply;
      case pathUrl.loanApply.calculation:
        return pathUrl.loanProductShelf;
      case pathUrl.personalInformation:
        return flow === FLOW_STATE.COMFIRM
          ? pathUrl.confirmingDetails
          : pathUrl.loanApply.apply;
      case pathUrl.additionalInformation:
        return flow === FLOW_STATE.COMFIRM
          ? pathUrl.confirmingDetails
          : pathUrl.personalInformation;
      case pathUrl.editInformation:
        return pathUrl.personalInformation;
      case pathUrl.confirmingDetails:
        return flow === FLOW_STATE.COMFIRM
          ? pathUrl.confirmingDetails
          : pathUrl.additionalInformation;
      case pathUrl.marketingConsent:
        return pathUrl.confirmingDetails;
      case pathUrl.ncbConsent:
        return pathUrl.marketingConsent;
      case pathUrl.confirmSummary:
        return pathUrl.confirmSummary;
      default:
        return '';
    }
  }

  getPageEvent() {
    const currentUrl = this.location.path();
    switch (currentUrl) {
      case pathUrl.loanApply.apply:
        return 'LoanWebLoanInfo';
      case pathUrl.loanApply.productDetail:
        return 'LoanWebSaleSheetPDF';
      case pathUrl.loanApply.calculation:
        return 'LoanWebLoanCalculation';
      case pathUrl.personalInformation:
        return 'LoanWebPersonalInformation';
      case pathUrl.additionalInformation:
        return 'LoanWebAdditionalInformation';
      case pathUrl.editInformation:
        return 'LoanWebUpdateInformation';
      case pathUrl.confirmingDetails:
        return 'LoanWebConfirmDetails';
      case pathUrl.marketingConsent:
        return 'LoanWebModelConsent';
      case pathUrl.ncbConsent:
        return 'LoanWebNCBConsent';
      default:
        return '';
    }
  }

  navigateTo(url: string = '') {
    const currentUrl = this.location.path();
    const previousUrl = this.previousUrl(currentUrl);

    const event = {
      action: 'Click',
      category: `DigitalLending_${this.getPageEvent()}`,
      label: `DigitalLending_${this.getPageEvent()}_Back`,
      value: null,
    };
    const dimension = [
      {
        key: 'PRODUCT_TYPE',
        value: this.productType,
      },
    ];
    if (currentUrl === pathUrl.loanApply.calculation) this.gaTagging(event);
    else this.gaTagging(event, dimension);

    if (
      (currentUrl === pathUrl.loanApply.apply ||
        currentUrl === pathUrl.loanApply.calculation) &&
      previousUrl !== pathUrl.confirmingDetails &&
      previousUrl !== pathUrl.loanApply.calculation
    ) {
      this.jsInterfaceService.exitFullScreen(previousUrl);
    } else {
      previousUrl ? this.router.navigate([previousUrl]) : this.location.back();
    }
  }

  close() {
    this.router.navigate(['/loan-product-shelf']);
  }

  gaTagging(event: EventGATagging, dimension?: CustomDimensions[]) {
    this.jsInterfaceService.gaTagging(event, dimension);
  }
}
